"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timezonesEpics = void 0;

var _utils = require("@alycecom/utils");

var _operators = require("rxjs/operators");

var _services = require("@alycecom/services");

var _timezones = require("./timezones.actions");

var loadTimezonesEpic = function loadTimezonesEpic(action$, state$, _ref) {
  var apiService = _ref.apiService;
  return action$.pipe((0, _utils.ofType)(_timezones.loadTimezonesRequest), (0, _operators.switchMap)(function () {
    return apiService.get('/api/v1/timezones', null, true).pipe((0, _operators.map)(function (_ref2) {
      var data = _ref2.data;
      return (0, _timezones.loadTimezonesSuccess)(data);
    }), (0, _operators.catchError)((0, _services.handleError)(_services.handlers.handleAnyError(_timezones.loadTimezonesFail))));
  }));
};

var timezonesEpics = [loadTimezonesEpic];
exports.timezonesEpics = timezonesEpics;